import classnames from "classnames";
import React from "react";
import styles from "./FieldWrapper.module.scss";

type Props = {
  className?: string;
  style?: Record<string, any>;

  children: React.ReactNode;
};

function WrapperBase({ className, style, children }: Props) {
  const finalClassName = classnames(styles.fieldWrapper, className);
  return (
    <div className={finalClassName} style={style}>
      {children}
    </div>
  );
}

export default WrapperBase;
